export default "__VITE_ASSET__BTDkD1FV__"